var findLayers = (map, predicate) => {
  var layers = map.getLayers().getArray();

  if (predicate) {
    return layers.filter(predicate);
  }

  return layers;
};

export function findLayersOfType(map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
layerClass, predicate) {
  var layers = map.getLayers().getArray().filter(layer => layer instanceof layerClass).map(layer => layer);
  if (predicate) layers = layers.filter((layer, index, layers) => predicate(layer, index, layers));
  return layers;
}
export default findLayers;